import { inject as service } from '@ember/service';
import { resolve } from 'rsvp';
import Base from 'ember-simple-auth/authenticators/base';
import { getAccessCookie } from 'cio/utils/auth-cookies';

import ApiService from 'cio/services/api';
import { LoginSuccessResponse } from 'cio/authenticators/login-email-password';
import { LoginMeta } from 'cio/pods/login/controller';
import AuthService from 'cio/services/auth';

// error returned by other authenticators when "login-2fa" has to be used
// custom error class is necessary to pass the JWT login token from the API response
export class TwoFactorAuthRequiredError extends Error {
  twoFactorAuthLoginToken: string;

  constructor(twoFactorAuthLoginToken: string, ...params: any) {
    super(...params);

    this.twoFactorAuthLoginToken = twoFactorAuthLoginToken;
  }
}

export default class LoginPasswordAuthenticator extends Base {
  @service api!: ApiService;
  @service auth!: AuthService;

  restore(_data: unknown) {
    return resolve({
      accessToken: getAccessCookie() as string,
    });
  }

  authenticate({
    twoFactorAuthLoginToken,
    twoFactorAuthCode,
    meta,
  }: {
    twoFactorAuthLoginToken: string;
    twoFactorAuthCode: string;
    meta: LoginMeta;
  }) {
    return this.api
      .post('login_2fa', {
        data: {
          '2fa_login_token': twoFactorAuthLoginToken,
          '2fa_code': twoFactorAuthCode,
          ga_client_id: meta.ga_client_id,
        },
        ignoreErrors: true,
        pathScope: 'global',
      })
      .then((res: LoginSuccessResponse) => {
        this.auth.setAccessCookiesAndExpiration(res.access_token, res.session_expires_at);
        return { accessToken: res.access_token };
      });
  }
}
